
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/[course]",
      function () {
        return require("private-next-pages/courses/[course].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/courses/[course]"])
      });
    }
  